import content, { format } from "./content";
import defaults from '../assets/contactStruct.json';
import { nightsBetween, stayPrice, frenchDate, today } from './data';
export function validateStay(gite, arrival, departure, people) {
  if (!gite) return content.pages.contact.form.errors.gite;
  if (!arrival || !departure || arrival < today() || !nightsBetween(arrival, departure)) return content.pages.contact.form.errors.dates;
  if (!Number.isInteger(Number(people)) || people < 1 || people > gite.maxclient) return content.pages.contact.form.errors.capacity;
  return '';
}
export function contactPayload(fields, gite) {
  const nights = nightsBetween(fields.arrival, fields.departure);
  return {
    ...defaults,
    client_nom: fields.lastName.trim(),
    client_prenom: fields.firstName.trim(),
    client_mail: fields.email.trim(),
    client_telephone: fields.phone.trim(),
    client_adresse: fields.address.trim(),
    contact_preference: fields.preference,
    gite_initial: gite.initial,
    gite_selected: gite.nom,
    lieu: gite.lieu,
    mail_sujet: format(content.pages.contact.form.subject, {
      name: gite.nom
    }),
    mail_message: fields.message.trim(),
    nombre_personnes: Number(fields.people),
    nombre_nuits: nights,
    sejour_debut: frenchDate(fields.arrival),
    sejour_fin: frenchDate(fields.departure),
    montant_sejour: stayPrice(gite, nights, Number(fields.people))
  };
}
